export default ['dhachayawat@gmail.com', 'panida.tham@hotmail.com', 'thegood.ad@gmail.com']



// WEBPACK FOOTER //
// ./src/config/admin.js